import React from 'react';
import { navLinks } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-[#0b0b0b] border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10 grid lg:grid-cols-3 gap-8 items-start">
        {/* Logo + legal */}
        <div className="space-y-3">
          <div className="flex flex-col leading-none">
            <span className="text-white font-black tracking-[0.18em] text-[18px]">
              LS<span className="text-[#e30613]">\</span>TOIT
            </span>
            <span className="text-[9px] tracking-[0.32em] text-white/50 mt-0.5">DACHY PŁASKIE</span>
          </div>
          <div className="pt-2 space-y-1 text-[11.5px] text-white/55 leading-relaxed">
            <p className="text-white/80 font-semibold tracking-wide text-[12px]">LE SEPTIEME TOIT</p>
            <p><span className="text-white/40">NIP:</span> 9241851371</p>
            <p><span className="text-white/40">REGON:</span> 369715569</p>
          </div>
        </div>

        {/* Nav */}
        <nav className="flex flex-wrap items-start lg:justify-center gap-x-5 gap-y-3 lg:pt-1">
          {navLinks.map((l) => (
            <a key={l.label} href={l.href} className="text-[10.5px] tracking-[0.14em] text-white/55 hover:text-white transition-colors duration-200">
              {l.label}
            </a>
          ))}
        </nav>

        {/* Contact + copyright */}
        <div className="lg:text-right space-y-1.5 text-[11.5px] text-white/55">
          <a href="tel:+48797219803" className="block text-white font-semibold tracking-wide hover:text-[#e30613] transition-colors duration-200">
            +48 797 219 803
          </a>
          <a href="mailto:kontakt@lstoit.pl" className="block text-white/80 hover:text-[#e30613] transition-colors duration-200">
            kontakt@lstoit.pl
          </a>
          <p className="pt-3 text-white/40">© 2024 wykonanie LE SEPTIEME TOIT.</p>
          <p className="text-white/35">Wszelkie prawa zastrzeżone.</p>
          <button
            onClick={() => window.dispatchEvent(new Event('open-cookie-settings'))}
            className="mt-2 text-[10.5px] tracking-[0.18em] text-white/55 hover:text-white transition-colors duration-200 underline-offset-2 hover:underline"
          >
            USTAWIENIA COOKIES
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
